// src/httpClient.js
import { fetchUtils } from "react-admin";

export const httpClient = (url, options = {}) => {
  const token = localStorage.getItem("basicAuth");

  options.user = {
    authenticated: !!token,
    token: token ? `Basic ${token}` : undefined,
  };

  return fetchUtils.fetchJson(url, options);
};
